import React, { useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

import ContactForm from '../components/ContactForm'
import ContactMap from '../components/ContactMap'

import { AppStateContext } from '../AppStateContext';
import { BsCheck } from 'react-icons/bs'

import { AiFillInstagram, AiFillMail, AiFillPhone, AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'
import { ImLocation } from 'react-icons/im'

const Contact = () => {

    const { language, setLanguage } = useContext(AppStateContext);

    const translations = {
        tr: {
            banner6text1: 'Bize Ulaşın',

        },
        en: {
            banner6text1: 'Contact Us',
            banner6text2: "Dt. Yeşim Alkan",
            banner6text3: "If you're considering dental treatment, we would be honored to work with you to help you achieve your desired results.",
            banner6text4: 'Contact us now to schedule a consultation and learn more about the services we offer.',
            banner6text5: "Thank you for your interest in our dental treatment operations in Istanbul.",
            banner6text6: 'We are dedicated to providing our patients with the highest quality of care in dental treatments.',
            banner6text7: 'We understand that each patient is unique and we strive to provide personalized treatment plans to help you achieve your desired results.',
            banner6text8: 'If you would like to schedule a consultation with our dental treatment experts, or if you have any questions about our services, please do not hesitate to contact us.',
            banner6text9: 'ASK THE DENTIST'
        },
        it: {
            banner6text1: 'Contattaci',
        },
    };

    const getText = (key) => {
        return translations[language][key] // Default to the provided key if translation is not found
    };

    const pageTitle = 'Contact Us - Dt. Yeşim Alkan';
    const metaDescription = 'Contact us now to schedule a consultation and learn more about the services we offer.';

    return (
        <div>
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={metaDescription} />
                <link rel="canonical" href="http://dtyesimalkan.com/contact" />
            </Helmet>
            <Navbar />
            <div className='w-full h-[120px]'></div>
            <div className='max-w-screen-xl w-full m-auto flex flex-col md:flex-row gap-10 my-10 md:my-20'>
                <div className='w-full md:w-1/2 flex flex-col px-5'>
                    <div className='text-2xl text-[#6DA5C0]'>{getText('banner6text1')}</div>
                    <div style={{ fontFamily: 'Righteous' }} className='text-4xl text-[#0F969C] pt-2 font-bold'>Dt.Yesim Alkan</div>
                    <div className='border-b-2 border-black pt-4 opacity-20'></div>
                    <div className='flex flex-row items-center gap-5 pt-5'>
                        <AiFillPhone size={20} className='text-[#0F969C] shrink-0' />
                        <div className=''>Tel: + 90 (533) 353 64 06</div>
                    </div>
                    <div className='flex flex-row items-center gap-5 pt-5'>
                        <AiFillMail size={20} className='text-[#0F969C] shrink-0' />
                        <div className=''>info@dtyesimalkan.com</div>
                    </div>
                    <div className='flex flex-row items-center gap-5 pt-5'>
                        <ImLocation size={20} className='text-[#0F969C] shrink-0' />
                        <div className=''>Bağdat Caddesi No:166/3, Palmiye Apt. Selamiçeşme, 34726 Kadıköy/İstanbul</div>
                    </div>
                    <div className='p-5'></div>
                    <ContactMap />
                </div>
                <div className='w-full md:w-1/2'>
                    <ContactForm />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Contact